export const CHANGE_CURRENT_SELECTED_ROLE =
  "[Currnt Looged in Role ] Change Current Selected Role";

// Common action
export const LIST_PERMISSION_KEY = "list";
export const CREATE_PERMISSION_KEY = "create";
export const UPDATE_PERMISSION_KEY = "update";
export const DELETE_PERMISSION_KEY = "delete";
